

























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { RejectedFile } from '@/shared/models/rejected-file'

@Component
export default class RespondecoRejectedFilesAlert extends Vue {
  @Prop({
    default: [],
    type: Array,
  })
  public readonly rejectedFiles!: RejectedFile[] | null
}
